import { Compatible, Choice, State } from 'shared'

export const checkCompatible = (
  compatible: Compatible | undefined,
  choices: Choice[]
): boolean => {
  const f = (componentId: string): string | undefined => {
    const choice = choices.find((c) => c.componentId === componentId)
    if (choice) return choice.optionId
  }
  let isCompatible = false

  if (
    compatible &&
    Object.prototype.hasOwnProperty.call(compatible, 'condition')
  ) {
    compatible.condition.forEach((item) => {
      const conditionalItem = f(item[0])
      if (conditionalItem === item[1]) {
        isCompatible = true
      }
    })
  }
  return isCompatible
}

export const parseIntWithFallback = (
  input: string,
  fallback: number
): number => {
  const value = parseInt(input, 10)
  if (isNaN(value) || value < 0) {
    return fallback
  } else {
    return value
  }
}

export const formatHistory = (state: State): Choice[][] => {
  let {
    undoCounter,
    undoed,
    bikeConfig: { choices }
  } = state
  if (!undoed) {
    return [...state.fullHistory, choices]
  } else if (undoed && undoCounter === 0) {
    return [...state.fullHistory]
  } else if (undoed && undoCounter > 0) {
    return splicer([...state.fullHistory], undoCounter)
  }
  return state.fullHistory // Ensure a return value in all cases
}

const splicer = (historyArray: Choice[][], undoCounter: number): Choice[][] => {
  let newHistory = [...historyArray]
  newHistory.splice(newHistory.length - undoCounter, undoCounter)
  return newHistory
}
